var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0038a8",
    d: "M.7 26.6H54V40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 13.3H54v13.4H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M.7 0H54v13.3H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M27.3 25.1a5.1 5.1 0 1 0 0-10.2 5.1 5.1 0 0 0 0 10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 24.2a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 23.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m24.6 22-.6.3-.2-.3v-.3h.3v-.1l.2-.2v.5l.2-.1zm-.5 0v-.1H24zm-.5-.5-.2-.5h.1l.2.3v-.4l.2.3h.1v-.4l.2.5zm-.3-.8v-.5h.4v.2h.3v.3zm.3-.2v-.1h-.1v.1zm-.3-1v-.3h.5v.1h.2v.5l-.2.1h-.5v-.2h.5v-.2zm.1-.6.2-.3v-.2h.2v.2l.2-.1h.1l.1.1v.2l-.1.4zm.3 0v-.2zm.3 0v-.2zm-.3-.8.2-.2.4.3.2-.3h.1l-.3.6zm.5-.6.1-.2.5.4-.1.2zm.9-.4h.2v.2l-.1.1-.2.1-.2-.1-.1-.3.1-.2.2-.1h.2l-.1.2H25l-.1.1v.1l.2.1h.1zm.7-.2h-.2v.2h-.2v-.6l.2-.1.5.4-.2.1m0-.2-.3-.1v.2zm.6-.7h.5l.1.1v.5h-.2l-.3.1zm.2.1v.4h.2v-.3zm.7-.2h.5v.2h-.3l.3.1v.1h-.4v.2h.4v.1h-.6zm.8 0 .2.1-.1.5.3.1v.2l-.6-.2zm1 .5.4.1.1.2v.1l-.2.1h-.2l-.2.2-.2-.2zm.1.3h.2v-.1zm.6.8-.2-.1-.2-.1.6-.4.2.2-.3.7zm0-.1.2-.3-.2.2m.2.4.5-.4.2.3.1.2v.2h-.3v.1l-.1.2-.2-.2.1-.2v-.1l-.2.1zm.4 0h.1v.1h.1v-.2zm.2 1v-.2h-.2v-.2h.7v.2l-.5.5zm.2 0 .2-.2h-.3zm.1.7h.2v.3h-.3v-.1l-.1-.2v-.2l.1-.1.2-.1h.2l.1.1.1.2v.2l-.2.1v-.2a.1.1 0 0 0 0-.2H31zm.5 1v.2H31l-.1-.1V20l.1-.1h.5v.2H31l-.1.1v.1zm-.8.7.1-.2v-.3l.6.5-.1.2h-.8zm.2 0h.2l-.2-.1zm.2.6v.2h-.4l.2.2-.1.2-.3-.4-.2-.2.1-.2.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M28 17.6s2 .8 1.6 2.6c-.3 1.7-1.4 1.7-1.8 1.9q-.7.4-1 .4l-.3-.1.3.3c.4 0 .8-.5 1-.5s1.6-.2 1.9-2c.4-1.9-1.7-2.5-1.7-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29 18v.1l-.1-.1v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29 18v.2l-.2-.2v-.2zm-.3.1h.2v.2l-.3-.1h-.1V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m28.8 18 .1.2-.3-.1-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m28.8 18 .2.2h-.2l-.2-.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29 18.3h-.2l-.1.1h.2zl.1-.1.2-.2H29v.2zm.6.2v.3h-.1V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.5 18.5v.4l-.1-.1-.1-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m29.2 18.6.2.1v.1h-.2l-.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m29.2 18.5.2.2v.2l-.5-.5v-.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.4 18.5v.2q.2.2 0 .2v-.1l-.3-.5V18v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.5 18.9H29l.1.1h.2zl.1-.1.2-.2v-.1h-.1l-.1.3zm.4.4v.3h-.2v-.1l.1-.6h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.8 19.3v.4h-.1v-.9.1zm-.3 0 .2.2v.2l-.3-.2-.2-.3-.1-.1q0-.2 0 0h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.6 19.2v.3l.1.1h-.1l-.2-.3-.1-.3v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.7 19.2v.4l-.2-.3v-.5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.7 19.7h-.1l-.2-.1h-.1v.1zl.2-.1.2-.1v-.2l-.2.1v.2zm.2.6-.2.2v-.1l.3-.5v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7 19.7h-.1l-.2-.1h-.1v.1zl.2-.1.2-.1v-.2l-.2.1v.2zm.2.6-.2.2v-.1l.3-.5v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.8 20.1v.3h-.2l.2-.7h.1v.4m-.3 0 .1.2v.2zl-.1-.3v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.6 20v.4l-.1-.5v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.7 20v.5l-.1-.2v-.7h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.6 20.4h-.1l-.1-.1h-.2.2zh.4q.2 0 .1-.2H30l-.1.1zm0 .7-.2.2h-.1v-.1l.3-.3.3-.3h.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 20.4h-.1l-.1-.1h-.2.2zh.4q.2 0 .1-.2H30l-.1.1zm0 .7-.2.2h-.1v-.1l.3-.3.3-.3h.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m29.6 21-.2.2h-.2l.6-.7v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.3 20.8v.6h-.1v-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.4 20.8v.2l-.1.1v-.3l.1-.6.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4 20.8v.2l-.1.1v-.3l.1-.6.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m29.5 20.9-.2.4v.1h-.1v-.2l.1-.4.2-.4.1-.2h.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29.2 21.3v-.1L29 21h-.2l.2.2zl.2.1.3.1h.1l-.2-.1h-.4m-.2.6h-.4l.1-.2h.8-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 21.3v-.1L29 21h-.2l.2.2zl.2.1.3.1h.1l-.2-.1h-.4m-.2.6h-.4l.1-.2h.8-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M29 21.8h-.5l.2-.1.7-.3h.1l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 21.8h-.5l.2-.1.7-.3h.1l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m28.9 21.4-.2.2-.1.1v-.4l.2-.3.1-.2h.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m29 21.4-.3.3h-.2l.5-.5V21h.3v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m29 21.6-.3.2-.2.1v-.2l.4-.3.3-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M28.5 21.8v-.3q0-.2-.2-.2v.1l.1.2zl.2.2.2.2h.2l-.2-.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 21.8v-.3q0-.2-.2-.2v.1l.1.2zl.2.2.2.2h.2l-.2-.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M28.2 22.3H28l-.2-.1.2-.1h.6v.2zm0-.4-.3.2-.2.1V22l.6-.6v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.2 21.9-.3.2-.2.1V22l.6-.6v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m28.2 22.1-.3.1h-.2l.1-.2.3-.2h.6l-.1.1zm.2-4.4.1.1-.4-.3zm-.2 0 .2.1v.1H28v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m28.3 17.7.2.1v.1h-.3l-.2-.2v-.1zM26 21.8l.8.3 1 .6q.4 0 .6-.3h-.7L27 22l-1-.3zm.4-3.8.5-.3-.5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.9 18h-.7l.4-.6-.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 18h-.7l.4-.6-.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.3 18 .5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 18 .5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.8 18h-.7l.4-.6-.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8 18h-.7l.4-.6-.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.3 18 .5-.2h-.6v.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 18 .5-.2h-.6v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.7 18h-.6l.3-.6-.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 18h-.6l.3-.6-.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.2 18 .4-.4zv.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.7 18.1H26l.3-.7-.1.6zm-.6 0 .5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.7 18.1h-.8l.4-.7-.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26 18.2.5-.5-.6.3v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.6 18.1-.8.2.3-.9-.1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 18.1-.8.2.3-.9-.1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26 18.2.3-.5-.5.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.4 18.2h-.7l.4-.7-.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.9 18.3.5-.5-.6.4v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.4 18.2-.8.2.3-.8-.1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.8 18.3.3-.6-.5.5v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 18.3.3-.6-.5.5v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.4 18.3-.8.2.2-1v.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 18.3-.8.2.2-1v.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.7 18.5.4-.7-.5.6v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.3 18.3-.8.3.2-1v.8zm-.7.3.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.2 18.4-.8.2.2-.9v.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 18.4-.8.2.2-.9v.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 18.6.6-.5-.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.1 18.5-.8.1.3-.9-.1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.4 18.6.4-.7-.5.6v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.4 18.6.4-.7-.5.6v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.1 18.4q-.4.3-.9.4l.2-1v.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.4 18.8.4-.8-.6.7v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26 18.5-.9.5.2-1.1v.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.3 18.9.3-.8-.5.7v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26 18.6-1 .4.2-1v.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.2 19 .5-.7-.6.6v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.9 18.6-.8.6v-1l.1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.9 18.6-.8.6v-1l.1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.2 19 .1-.9-.2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.8 18.7-.8.6v-1q0 .4.2.7.3 0 .6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.2 19.2.2-.9-.4.8v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.8 18.7-.7.7-.2-1q0 .4.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 18.7-.7.7-.2-1q0 .4.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25.2 19.3v-1l-.2 1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.7 18.8-.8.7v-1.1l.2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.7 18.8-.8.7v-1.1l.2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.1 19.4.3-.9zv.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.7 18.8-.7.8-.2-1.1.3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25.1 19.5v-1l-.2 1 .1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.6 18.9-.7.8-.2-1.1.3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25 19.5.2-.9zv.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25.6 19q-.4.3-.6.8l-.3-1.1.3.7q.3-.1.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 19q-.4.3-.6.8l-.3-1.1.3.7q.3-.1.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25 19.6v-1l-.1 1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 19.6v-1l-.1 1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.6 19-.6.9q-.1-.6-.4-1.1l.4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.1 19.7.1-1zv.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 19-.5 1-.4-1 .4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 19-.5 1-.4-1 .4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.1 19.8-.3-.9.1 1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.1 19.8-.3-.9.1 1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 19.2-.5 1-.4-1.1.4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 19.2-.5 1-.4-1.1.4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25.1 20v-1l-.2 1 .1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 19.3-.5.9-.4-1 .4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.1 20-.2-.9v1l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 19.4-.6.9q-.1-.6-.4-1l.4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25 20.1.1-.9-.3.9.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 19.4-.5 1-.5-1 .5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 19.4-.5 1-.5-1 .5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25 20.2-.3-.9.1 1 .1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 20.2-.3-.9.1 1 .1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.4 19.5-.3 1-.6-.8.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.2 20.3-.3-.9.2 1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.4 19.6-.3 1-.6-.8.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.2 20.4-.4-.8.3 1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2 20.4-.4-.8.3 1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.4 19.7-.2 1-.7-.7.6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.3 20.6-.2-1v1l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 20.6-.2-1v1l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25.4 19.8v1l-.9-.6.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 19.8v1l-.9-.6.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.3 20.6-.6-.6.4.8h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25.4 19.9v1l-.9-.6.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.4 20.8-.5-.8.3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.4 20.8-.5-.8.3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 20-.1 1.1-.8-.6.7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 20-.1 1.1-.8-.6.7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.4 21-.5-.8.4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25.5 20.2v1l-1-.6.8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 20.2v1l-1-.6.8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 21-.4-.8.2 1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M25.5 20.2v1.2l-.8-.5.7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 21-.7-.5.6.7h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 20.3.1 1.1-.9-.5.7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.6 21.2-.6-.7.5.8h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6 21.2-.6-.7.5.8h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.5 20.4.2 1.1-1-.4.8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.7 21.3-.7-.5.6.7h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.6 20.5.2 1.1-1-.3h.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.8 21.4-.6-.7.4.8.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.6 20.6.3 1.1-1-.2h.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6 20.6.3 1.1-1-.2h.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.8 21.4-.8-.2.8.4h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 21.4-.8-.2.8.4h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.7 20.7.3 1-1-.1h.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26 21.5-.8-.4.7.6h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.6 20.8.6 1h-1l.7-.2q0-.5-.3-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26 21.6-.7-.2.7.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 21.6-.7-.2.7.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.7 20.9.6 1h-1l.7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.7 20.9.6 1h-1l.7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.2 21.6-.8-.4.7.6h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.8 21 .6.9-1 .1.7-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.2 21.7h-.8l.8.2h.2zm.5-3.9h.6zh-.1zm.3.2-.6-.2.6-.3-.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.7 17.8.5-.1zv.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.7 17.8.5-.1zv.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M27 18h-.7l.5-.5-.3.4zm-.5-.1h.5zh-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 17.9h.5zh-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.9 18-.6-.1.5-.3-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.4 17.9.5-.2zh-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.9.5-.2zh-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.9 18-.5-.1.3-.4-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.4 18 .4-.2h-.4zm-.3 3.6h-.8l.8.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.3 21.7-.9-.2.8.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.4 21.7h-.8l.8.3.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m25.9 21.2.7.8-1 .2q.5 0 .7-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.5 21.8-.8-.3.8.5h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 21.8-.8-.3.8.5h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26 21.2.8.8-1 .3.7-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.6 21.8-.8.2h.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 21.8-.8.2h.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.4 21.8h-.8l.8.2.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 21.8h-.8l.8.2.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.6 21.8-.9-.1.8.3h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "M26.7 21.9H26l.8.2.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.1 21.3.9.8-1 .3.7-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.8 22-.8-.3zh.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.2 21.4 1 .7q-.6.1-1 .4l.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009b3a",
    d: "m26.9 22-.8.2h.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fedf00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m28 20.8-.7-.4-.6.4.2-.7-.5-.4h.7l.2-.7.3.7h.7l-.6.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPy);
export default __webpack_public_path__ + "static/media/py.b9c0ba0fb766ac6c1174234b32d66939.svg";
export { ForwardRef as ReactComponent };